import React from 'react';
import { PopupNotification } from './components/PopupNotification';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { MiniTestimonials } from './components/MiniTestimonials';
import { PainSection } from './components/PainSection';
import { ProductSection } from './components/ProductSection';
import { BonusesSection } from './components/BonusesSection';
import { UrgencyCountdown } from './components/UrgencyCountdown';
import { PricingSection } from './components/PricingSection';
import { ComparisonTable } from './components/ComparisonTable';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { FooterSection } from './components/FooterSection';
export function App() {
  return <div className="w-full min-h-screen bg-bg-main text-[#2C2C2C] font-serif overflow-x-hidden" data-id="element-0" data-mp="23v2uj6wqr76z">
      <PopupNotification data-id="element-1" data-mp="3ijpdn24eb1aa" />
      <UrgencyBar data-id="element-2" data-mp="3mlj82snzz920" />
      <HeroSection data-id="element-3" data-mp="3ml12h5fg3ihf" />
      <MiniTestimonials data-id="element-4" data-mp="3mkhou0wtvg97" />
      <PainSection data-id="element-5" data-mp="3mjq3diwy2ywn" />
      <ProductSection data-id="element-6" data-mp="3mj6jhwnqi0fz" />
      <BonusesSection data-id="element-7" data-mp="3rbra6pbcfxfa" />
      <UrgencyCountdown data-id="element-8" data-mp="3rdarmj8qkein" />
      <PricingSection data-id="element-9" data-mp="3rd19tixuhdo1" />
      <ComparisonTable data-id="element-10" data-mp="3relwkmdx3sbc" />
      <GuaranteeSection data-id="element-11" data-mp="6hovayao7c0" />
      <TestimonialsSection data-id="element-12" data-mp="4n53zyrel9i" />
      <FAQSection data-id="element-13" data-mp="82kz509bybz" />
      <FinalCTA data-id="element-14" data-mp="2zl3azit8d249" />
      <FooterSection data-id="element-15" data-mp="2zlle8zeb8glo" />
    </div>;
}